import React from "react";
import SportFilter from "./SportFilter";
import GamesLinksPanel from "./GamesLinksPanel";
import PropTypes from "prop-types";
import {defineMessages, injectIntl, intlShape} from "react-intl";
import NavItemExternalLink from "../Common/Nav/NavItem/NavItemExternalLink";

class GamesMenu extends React.PureComponent {

    ALL_SPORTS_OPTION = null;

    static defaultProps = {
        games: [],
        sports: [],
        updated: [],
    };

    static propTypes = {
        menu: PropTypes.shape({
            value: PropTypes.shape({
                games: PropTypes.arrayOf(
                    PropTypes.shape({
                        id: PropTypes.number.isRequired,
                        name: PropTypes.string.isRequired,
                        sport: PropTypes.string.isRequired,
                    })).isRequired,
                sports: PropTypes.arrayOf(
                    PropTypes.shape({
                        name: PropTypes.string.isRequired,
                        slug: PropTypes.string.isRequired,
                    })).isRequired,
            }),
            key: PropTypes.shape({
                status: PropTypes.oneOf(['finished', 'live', 'pre-live']),
                scope: PropTypes.oneOf(['my', 'all', 'admin'])
            })
        }),
        updated: PropTypes.array.isRequired,
        intl: intlShape.isRequired,
    };


    constructor(props) {
        super(props);

        this.ALL_SPORTS_OPTION = {
            slug: 'all-sports',
            name: this.props.intl.formatMessage(messages.allSportsFilter)
        };

        this.state = this.parsePropsToState(props);

        this.handleFilterOnSport = this.handleFilterOnSport.bind(this);
    }

    parsePropsToState(props) {
        return {
            sportFilter: this.ALL_SPORTS_OPTION,
            sportFilterOptions: [this.ALL_SPORTS_OPTION, ...props.menu.value.sports],
        }
    }

    render() {
        let {updated, intl} = this.props;
        return <div>
            <SportFilter
                filterOptions={this.state.sportFilterOptions}
                name={intl.formatMessage(messages.filterOnSport)}
                currentFilter={this.state.sportFilter}
                onFilterOnSport={this.handleFilterOnSport}
            />
            <GamesLinksPanel
                games={this.getGames()}
                updated={updated}
                name={intl.formatMessage(messages.games)}>
                {this.renderCalendarLink()}
            </GamesLinksPanel>

        </div>
    }

    getGames() {
        let {games} = this.props.menu.value;

        if (this.state.sportFilter === this.ALL_SPORTS_OPTION) {
            return games;
        }

        return games.filter(game => game.sport === this.state.sportFilter.slug);
    }

    handleFilterOnSport(sport) {
        if (sport.slug === 'all-games') {
            this.setState({sportFilter: null});
            return;
        }

        this.setState({sportFilter: sport});
    }

    componentWillUpdate(nextProps) {
        if (nextProps.menu.value.sports === this.props.menu.value.sports) {
            return;
        }

        this.setState(this.parsePropsToState(nextProps))
    }

    renderCalendarLink() {
        let {menu, intl} = this.props;

        if(menu.key.status !== 'finished') {
            return null;
        }

        return <nav className="nav-list nav-list--striped"><NavItemExternalLink
            href="/main/calendar"
            title={intl.formatMessage(messages.calendarLink)}/></nav>;
    }
}

const messages = defineMessages({
    allSportsFilter: {
        id: 'gamesMenu.allSportsFilter'
    },
    filterOnSport: {
        id: 'gamesMenu.filterOnSport'
    },
    games: {
        id: 'gamesMenu.games'
    },
    calendarLink: {
        id: 'gamesMenu.calendarLink'
    }
});

export default injectIntl(GamesMenu)